import { largeCornerRadius, neutralAttributeColour, white } from 'Theme';

const styles = {
  avatar: {
    bgcolor: '#ffffff5e',
    height: 80,
    width: 80,
  },
  avatarContainer: {
    alignItems: 'flex-end',
    display: 'flex',
  },
  button: {
    color: white,
    fontWeight: '600',
  },
  card: {
    bgcolor: neutralAttributeColour,
    borderRadius: largeCornerRadius,
    color: white,
  },
  chipContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  contents: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    px: 2,
  },
  title: {
    color: white,
    fontSize: '1.25rem',
    fontWeight: 'bold',
  },
};

export default styles;
